const theme = {
  name: "My UAE Startup",
  fullName: "Ramkumar",
  url: "",
  author: {
    name: "My UAE",
    profile_url: "",
  },
  contacts: {
    address: "Dubai",
    email: "info@myuaestartup.com",
    phone: "1234567890",
  },
};

export default theme;
